export default "__VITE_ASSET__DZx6cn0I__"